import request from "../utils/request"

export function qqLogin(data) {
  return request({
    url: '/oauth/qq',
    method: 'get',
    params: data
  })
}

export function infoThirdUserSelf(data) {
  return request({
    url: '/portal/infoThirdUserSelf',
    method: 'get',
    params: data
  })
}

export function qqLogout() {
  return request({
    url: '/logout',
    method: 'post',
  })
}

export function selectThirdUserInfo() {
  return request({
    url: '/users/info/qquser',
    method: 'get',
  })
}




// WEBPACK FOOTER //
// ./src/api/user.js